module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpanded.470f515.eot";